<template>
  <header class="app-header" :class="{ 'app-header--fixed': fixed }">
    <div class="container">
      <header-nav />
      <header-user />
    </div>
  </header>
</template>

<script>
import HeaderNav from './HeaderNav';
import HeaderUser from './HeaderUser';

export default {
  name: 'app-header',
  components: { HeaderNav, HeaderUser },
  props: {
    fixed: {
      type: Boolean,
      required: false,
    },
  },
  mounted() {
    if (this.fixed) {
      this.setFixed();
    }
  },
  methods: {
    setFixed() {
      document.getElementById('app').style.paddingTop = '68px';
    },
    setUnfixed() {
      document.getElementById('app').style.paddingTop = '';
    },
  },
  watch: {
    fixed: function(newVal) {
      if (newVal) {
        this.setFixed();
      } else {
        this.setUnfixed();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$header-height: 72px;
$header-border-width: 4px;

.app-header {
  background: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: $header-height - $header-border-width;
  align-items: center;
  padding: 0 2rem;
  border-bottom: 1px solid color('grey');
  margin-top: $header-border-width;
  z-index: 1100;

  &--fixed {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    margin-top: 0;
    z-index: 1100;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(6px);
  }

  &:before {
    content: '';
    height: $header-border-width;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: color('secondary');
    background-image: linear-gradient(
      90deg,
      color('twitch'),
      color('secondary')
    );
  }
}
</style>
